import store from "@/utils/store";
export const list = {
    data() {
        return {
            store: {
                data: [],
                isVanLoading: false,
                isLoading: false,
                isError: false
            }
        };
    },
    methods: {
        // 加载store
        storeLoad(params) {
            store.load(
                this.store,
                params
            );
        },
        // 清空store
        storeRemoveAll() {
            this.store.data = [];
        },
        storeReLoad() {
            store.reLoad(
                this.store
            );
        }
    }
}